import ModusServiceCollection from "../ModusServiceCollection";
import LaboratoryTestPackageModel from "../../models/modus/LaboratoryTestPackageModel";

/**
 * LaboratoryTestPackage collection
 */
export default class LaboratoryTestPackageCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return LaboratoryTestPackageModel;
  }

}
